export default __webpack_public_path__ + "static/media/cabinet1-after-480w.db2ea661.png";